module.exports = __webpack_public_path__ + "img/img (23).81468417.png";